import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'list-clients',
  templateUrl: './list-clients.component.html',
  styleUrls: ['./list-clients.component.scss']
})
export class ListClientsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
